import { HttpRequest, HttpEvent, HttpHandlerFn } from '@angular/common/http';
import { Observable } from 'rxjs';

export const ACCOUNT_HEADER_KEY = 'COMPANY';
export const ACCOUNT_LOCAL_STORAGE_KEY = 'accountId';

export function accountInterceptor(request: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const accountId = window.localStorage.getItem(ACCOUNT_LOCAL_STORAGE_KEY);

  if (accountId) {
    const cloned = request.clone({
      headers: request.headers.set(ACCOUNT_HEADER_KEY, accountId)
    });
    return next(cloned);
  } else {
    return next(request);
  }
}
